import { Container, Message } from '@prism/library';
export default function PrivateRouteNoLdap() {
  return (
    <>
      <Container className="container p-3 white">
        <Message isOpen={true} title="Access Denied: Missing Required LDAP Role" color="warning" toggle={() => true}>
          <p>You are successfully authenticated, however your account does not have one of the required roles to access this application.</p>
          <p>To proceed, your login must be associated with at least one of the following LDAP roles:</p>
          <ul>
            <li>Service_Looker</li>
            <li>Service_Admin</li>
            <li>Service_CCTier2</li>
            <li>Service_CCEdit</li>
            <li>Service_CIManager</li>
          </ul>
          <p>Please contact your administrator or support team to request access.</p>
          <a href="https://coxauto.service-now.com/ess?id=sc_cat_item&sys_id=7fda2e17db2a1fc4143b69c3ca9619d7" target="_blank" rel="noopener noreferrer">
            <strong>Click here to submit a request for access. (IAM Engineering SNOW Ticket)</strong>
          </a>
        </Message>
      </Container>
    </>
  );
}
